import { PlaceholderTextCell, TextCellFormatter, TypedBodyCellProps } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { Formatters, Messages } from '../../../../gen-src/Localize';

export type TagCellFormatterProps = {
  readonly tags: ReadonlyArray<string>;
};

function TagCellFormatter(props: TagCellFormatterProps): JSX.Element {
  if (props.tags.length > 0) {
    const tagsList = props.tags.join(', ');
    const count = <span>{Messages.TotalCount({ count: Formatters.formatCount(props.tags.length) })}</span>;

    return (
      <TextCellFormatter text={tagsList} useWidgetsTooltip={true} postIcon={count} />
    );
  } else {
    return (
      <PlaceholderTextCell placeholderText={Messages.NoTagsAvailable()} />
    );
  }
}

export function createTagCellFormatter<T>(
  getTagsFromRowData: (rowData: T) => ReadonlyArray<string>,
): React.Factory<TypedBodyCellProps<T>> {
  return (props: TypedBodyCellProps<T>) => (
    <TagCellFormatter tags={getTagsFromRowData(props.row.data)} />
  );
}
